var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#2D115C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1232 18.9562C28.1232 14.7575 25.9086 13.2625 24.0853 12.5359C23.8338 12.4312 23.6312 12.2216 23.5404 11.9631C23.219 10.9082 22.3248 10 21.1302 10C19.9355 10 19.0413 10.9082 18.72 11.9631C18.6291 12.2216 18.4335 12.4312 18.175 12.5359C16.3517 13.2625 14.1371 14.7575 14.1371 18.9562C14.1371 23.539 13.1451 24.2376 11.7409 25.9003C11.161 26.585 11.685 27.8774 12.7049 27.8774H29.5554C30.5684 27.8774 31.0993 26.585 30.5195 25.9003C29.1153 24.2376 28.1232 23.539 28.1232 18.9562Z",
    fill: "#2D115C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2323 28.877C24.2183 28.877 24.2043 28.877 24.1904 28.877H18.0566V28.8839C17.868 28.8839 17.7143 29.0376 17.7073 29.2263C17.7073 29.2402 17.7073 29.2542 17.7073 29.2612C17.9029 30.868 19.328 31.6295 21.1235 31.6295C22.8979 31.6295 24.3161 30.84 24.5327 29.2612C24.5536 29.0726 24.4209 28.8979 24.2323 28.877Z",
    fill: "#2D115C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotifications);
export default __webpack_public_path__ + "static/media/ic_notifications.974b26ee6d81b3687c102073a522cfa1.svg";
export { ForwardRef as ReactComponent };